import React, { useState } from 'react';
import { Config, I18n } from '@deporvillage/utils-library-component';
import SubscriptionForm from '@deporvillage/subscription-form-component';

import styles from './SubscriptionInlineForm.module.scss';

const MobileThresholdWidth = 1035;

const FormWithSidebar = () => {
    const [toggle, setToggle] = useState(false);
    const handleToggle = () => setToggle(!toggle);
    return (
        <div className={`${ styles['subscription-inline-form-component'] } ${ toggle ? styles.toggle : '' }`}>
            <div className={ styles['toggle-bar']} onClick={ handleToggle } data-testid='sidebar-toggle'>
                <span className={`icon icon-down ${ styles.icon }`}></span>
                <span><I18n>subscribe.form.discount_percent</I18n></span>
            </div>
            <div className={ styles['form-wrapper'] }>
                <SubscriptionForm />
            </div>
        </div>
    );
};

const SubscriptionInlineForm = () => {
    const { width } = React.useContext(Config);
    return width && width < MobileThresholdWidth ? <SubscriptionForm/> : <FormWithSidebar/>;
};

export default SubscriptionInlineForm;
